import {createTheme, ThemeOptions} from '@mui/material/styles';
import '@mui/x-data-grid/themeAugmentation';


const adyenTheme = createTheme(
    {
        components: {
            MuiDataGrid: {
                defaultProps: {
                    rowHeight: 38.5,
                },
                styleOverrides: {
                    root: {
                        border: 'none',
                    },
                    columnHeaders: {
                        height: '38.5px',
                        minHeight: '38.5px',
                        maxHeight: '38.5px',
                        backgroundColor: 'white',
                        fontWeight: 500,
                        fontSize: '1rem',
                        textAlign: 'center',
                    },
                    columnHeaderTitle: {
                        fontWeight: 'bold',
                        width: '100%',
                        textAlign: 'center',
                        fontSize: '12px',
                        color: '#666',
                        letterSpacing: '.5px',
                        textTransform: 'uppercase',
                    },
                    cell: {
                        color: '#333',
                        fontSize: '14px',
                        fontFamily: 'Fakt, Inter, Arial, sans-serif',
                    },
                    cellContent: {
                        color: '#333',
                        fontSize: '14px',
                        fontFamily: 'Fakt, Inter, Arial, sans-serif',
                    },
                    columnSeparator: {
                        display: 'none',
                    },
                    columnHeader: {
                        justifyContent: 'center',
                    },
                    row: {
                        borderBottom: '1px solid #eee',
                    },
                },
            },
        },
    } as ThemeOptions
);

export default adyenTheme;